import DashboardLearningList from "./DashboardLearningList";

export default DashboardLearningList;